import { ErrorHandler, Injectable } from '@angular/core';
import { KieneBackendApiService } from '../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { PosthogService } from '../../../projects/kiene-core/src/lib/services/posthog/posthog.service';
import { environment } from '../../environments/environment';

@Injectable()
export class KieneErrorsHandler implements ErrorHandler {
    constructor(private api: KieneBackendApiService, private posthog: PosthogService) {}

    handleError(error: unknown): void {
        this.posthog.captureException(error);
        this.api.handleException(environment.production, error instanceof Error ? error : new Error(String(error)));
    }
}
